module.exports = __webpack_public_path__ + "img/brink-bg.39d6e352.png";